import React from 'react';

import { MarkdownService } from 'apps/auth/services/MarkdownService';

import ReferralQRCode from './ReferralQRCode';
import styles from './referralQRCode.module.css';
import { PaysendVectorLogo, PersonIcon } from './referralQRCodeIcons';

const getDisplayUrl = (referralLink) => {
    if (!referralLink) {
        return '';
    }
    try {
        return decodeURIComponent(referralLink).replace(/^https?:\/\//, '');
    } catch {
        return referralLink;
    }
};

const ReferralQRCodeCard = ({ name = 'John', referralLink, title, text1, text2 }) => {
    return (
        <div className={styles.card}>
            <div className={styles.brandRow}>
                <PaysendVectorLogo />
            </div>
            <div className={styles.inviteRow}>
                <PersonIcon size={24} />
                <div className={styles.inviteText}>
                    <span className={styles.inviteName}>{name}</span>
                    <span className={styles.inviteSubtitle}>{title}</span>
                </div>
            </div>
            <div className={styles.qrFrame}>
                <ReferralQRCode sharedLink={referralLink} size={180} />
            </div>
            <div className={styles.footerText}>{MarkdownService.removeNewlines(text1)}</div>
            <div className={styles.urlPill}>{getDisplayUrl(referralLink)}</div>
            <div className={styles.footerText}>{text2}</div>
        </div>
    );
};

export default ReferralQRCodeCard;
